import React from 'react';
import { Label, Tooltip } from '@patternfly/react-core';
import { getLabelColor } from '../../utils';

interface IssueLabelsCellProps {
  labels?: string[];
  countClassName?: string;
}

export const IssueLabelsCell: React.FC<IssueLabelsCellProps> = ({ labels, countClassName }) => {
  if (!labels || labels.length === 0) return null;

  if (labels.length === 1) {
    return <Label isCompact color={getLabelColor(labels[0])}>{labels[0]}</Label>;
  }

  return (
    <Tooltip content={labels.map((lbl) => (
      <Label key={lbl} isCompact color={getLabelColor(lbl)} style={{ marginRight: 4 }}>{lbl}</Label>
    ))}>
      <span className={countClassName}>{labels.length}</span>
    </Tooltip>
  );
};
